var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runtime } from '../Runtime';
import { BrowserRender } from './modules/BrowserRender';
import { BrowserDevice } from './modules/BrowserDevice';
import { BrowserAddressBar } from './modules/AddressBar/BrowserAddressBar';
import { BrowserIncludes } from './modules/BrowserIncludes';
import { BrowserConfig } from './modules/BrowserConfig';
import { BrowserPage } from './modules/BrowserPage';
import { BrowserWindow } from './modules/BrowserWindow';
import { BrowserStaging } from './modules/BrowserStaging';
import { BrowserBuild } from './modules/BrowserBuild';
import { BrowserKeyboard } from './modules/BrowserKeyboard';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { BrowserAgent } from './modules/BrowserAgent';
import { BrowserCleanup } from './modules/BrowserCleanup';
import { BrowserBoot } from './modules/BrowserBoot';
import { BrowserHostname } from './modules/BrowserHostname';
import { BrowserFullscreen } from './modules/BrowserFullscreen';
import { BrowserDragDrop } from './modules/BrowserDragDrop';
import { BrowserLocation } from './modules/BrowserLocation';
import { BrowserMouse } from './modules/BrowserMouse';
import { BrowserPreload } from './modules/BrowserPreload';
import { BrowserStylesheets } from './modules/BrowserStylesheets';
import { BrowserServiceWorker } from './modules/BrowserServiceWorker';
import { BrowserBandwidth } from './modules/BrowserBandwidth';
import { BrowserExtraContent } from './modules/BrowserExtraContent';
import { BrowserAlert } from './modules/BrowserAlert';
import { BrowserClipboard } from './modules/BrowserClipboard';
import { BrowserTab } from './modules/BrowserTab';
import { App } from '../../app/App';
import { localStore, sessionStore } from '../../../utils/mobx/localStorage/MobxLocalStorage';
import { BrowserMediaDevices } from './modules/BrowserMediaDevices';
import { BrowserWordlist } from './modules/BrowserWordlist';
import { BrowserModal } from './modules/BrowserModal';
export class BrowserRuntime {
    parent;
    constructor(parent) {
        this.parent = parent;
        // observe browser cookies for changes
        /* currently not working
        if (!!browser && browser.cookies) {
          browser.cookies.onChanged.addListener(() => {
            this.app.appCookies.readFromBrowser();
          });
        }
    */
    }
    get runtime() {
        return this.parent;
    }
    get app() {
        return App.fromSerialized({ id: this.browserTab.tabId });
    }
    browserBoot = new BrowserBoot(this);
    browserRender = new BrowserRender(this);
    browserBuild = new BrowserBuild(this);
    browserStaging = new BrowserStaging(this);
    browserWindow = new BrowserWindow(this);
    browserConfig = new BrowserConfig(this);
    browserPage = new BrowserPage(this);
    browserKeyboard = new BrowserKeyboard(this); // needs to be initialized
    browserDevice = new BrowserDevice(this);
    browserIncludes = new BrowserIncludes(this);
    browserFullscreen = new BrowserFullscreen(this);
    browserCleanup = new BrowserCleanup(this);
    browserServiceWorker = new BrowserServiceWorker(this);
    get browserTab() {
        return new BrowserTab(this);
    }
    get browserHear() {
        return new runtime.solidPackages.Exotic.classes.Hear(this.app);
    }
    get browserExtraContent() {
        return new BrowserExtraContent(this);
    }
    get browserAddressBar() {
        return new BrowserAddressBar(this);
    }
    get browserModal() {
        return new BrowserModal(this);
    }
    get browserMouse() {
        return new BrowserMouse(this);
    }
    get browserClipboard() {
        return new BrowserClipboard(this);
    }
    get browserBandwidth() {
        return new BrowserBandwidth(this);
    }
    get browserPreload() {
        return new BrowserPreload(this);
    }
    get browserLocation() {
        return new BrowserLocation(this);
    }
    get browserDragDrop() {
        return new BrowserDragDrop(this);
    }
    get browserHostname() {
        return new BrowserHostname(this);
    }
    get browserAgent() {
        return new BrowserAgent(this);
    }
    get browserStylesheets() {
        return new BrowserStylesheets(this);
    }
    get browserAlert() {
        return new BrowserAlert(this);
    }
    /*
    @memoize
    get browserAudioOut() {
      return new BrowserAudioOut(this);
    }
  */
    get browserMediaDevices() {
        return new BrowserMediaDevices(this);
    }
    get browserAudioRecorder() {
        return new runtime.solidPackages.Edit.classes.BrowserAudioRecorder(this);
    }
    get browserVideoRecorder() {
        return new runtime.solidPackages.Edit.classes.BrowserVideoRecorder(this);
    }
    get browserWordlist() {
        return new BrowserWordlist(this);
    }
    get sessionStore() {
        return sessionStore;
    }
    get localStore() {
        return localStore;
    }
}
__decorate([
    memoize
], BrowserRuntime.prototype, "app", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserTab", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserHear", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserExtraContent", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserAddressBar", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserModal", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserMouse", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserClipboard", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserBandwidth", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserPreload", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserLocation", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserDragDrop", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserHostname", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserAgent", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserStylesheets", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserAlert", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserMediaDevices", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserAudioRecorder", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserVideoRecorder", null);
__decorate([
    memoize
], BrowserRuntime.prototype, "browserWordlist", null);
